import apiClient from './config';

// El centro cancela una clase o reserva una recuperación EN NOMBRE de un cliente
// (para quien no tiene correo, y por tanto portal, o llama por teléfono). El
// back aplica las mismas reglas que el portal: ventana de cancelación, plazo y
// nivel de la recuperación, aforo.

export interface CancelarPorClienteResponse {
    recoveryGranted: boolean;
    recoveryDeniedReason: 'late' | 'outside_horizon' | null;
    rescheduleDeadline: string | null;
    minCancellationHours: number;
    cancellationHorizonDays: number | null;
}

export interface ClienteConRecuperacion {
    _id: string;
    nombre: string;
    telefono?: string;
    email?: string | null;
    /** Caducidad de la recuperación que se gastaría (la que antes caduca). */
    rescheduleDeadline: string;
}

export const cancelarPorCliente = async (eventId: string, clientId: string): Promise<CancelarPorClienteResponse> => {
    const response = await apiClient.post(`/eventos/${eventId}/cancelar-por-cliente`, { clientId });
    return response.data;
};

export const anadirConRecuperacion = async (eventId: string, clientId: string) => {
    const response = await apiClient.post(`/eventos/${eventId}/anadir-con-recuperacion`, { clientId });
    return response.data;
};

export const fetchClientesConRecuperacion = async (eventId: string): Promise<ClienteConRecuperacion[]> => {
    const response = await apiClient.get(`/eventos/${eventId}/clientes-con-recuperacion`);
    return response.data;
};
